import { Component, Input, OnInit,Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap'
import { TenderSelectProductsComponent } from '../tender-select-products/tender-select-products.component';
import { TenderSelectProductsConfirmBidComponent } from '../tender-select-products-confirm-bid/tender-select-products-confirm-bid.component';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { Router } from '@angular/router';
import { NgClass, NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { AllowNegativeDecimalNumber, CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective } from '../two-digit-decima-number.directive';
import { I18nModule } from '@spartacus/core';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
    selector: 'app-tender-select-products-place-bid',
    templateUrl: './tender-select-products-place-bid.component.html',
    styleUrls: ['./tender-select-products-place-bid.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    imports: [NgClass, NgIf, FormsModule, NgFor, ReactiveFormsModule, NgbInputDatepicker, AllowNegativeDecimalNumber, CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective, DecimalPipe, DatePipe, I18nModule]
})
export class TenderSelectProductsPlaceBidComponent implements OnInit {
  QPstartDate: NgbDate = null;
  QPendDate: NgbDate = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  form: UntypedFormGroup;
  @Input() qpStartDt;
  @Input() qpEndDt;
  qpSD:any;
  qpED:any;
  finalQPFromoDateErr:boolean=false;
finalQPToDateErr:boolean=false
isFinalQPFromDateValid:boolean=false;
isFinalQPToDateValid:boolean=false;
isFinalQPToGreater:boolean=false;
convertedDate: any;
  hoveredDate: NgbDate | null = null;
  private modalRef: NgbModalRef;
  div1: boolean = true;
  activeTab = 'none';
  priceTab = 'none';
  COI: boolean = false;
  OpenNegotiation: boolean = true;
  @Input() code: any;
  @Input() price: any;
  @Input() indexPrice: number;
  @Input() tabName: any;
  @Input() index: any;
  @Input() indexValue: any;
  @Input() parameter = [];
  @Input() quantity: any;
  @Input() value: any;
  @Input()disabled:boolean;
  @Input() dischargePortshw:any;
  @Input() fixedDisabled:boolean;
  @Input() indexDisabled:boolean;
  QPValuSelectedError: boolean =false;
  productInfo: any;
  Info: any;
  priceVal: any;
  materialFixedPrice1: any;
  materialIndexPrice1: any;
  materialIndex = 1;
  checkbox: any
  InitialValue: number;
  FinalValue: number;
  InitialActive: boolean;
  FinalActive: boolean;
  isHidde = false;
  isHidden = false;
  isHidden1 = false;
  isHidden2 = false;
  isHidden3 = false;
  dupData:any;
  defaultPrice:any;
  fixedPriceDisabled:boolean = false;
  pricingOptionsTodisplay:Array<any>;
  
  indexPriceDisabled:boolean = false;
isDisabled:boolean=false;
pricingTabFlag :boolean = false;
//qpDatesRequired: boolean = false;
  IndexPriceEmpty: boolean = false;
  FixedPriceEmpty: boolean = false;
  qpOptionsArray=[];  
  displayFixedQPSection =false;  selectedPricingOptions : any[];
  priceModel: any;
defaultValue:any =null;
  constructor(public activeModal: NgbActiveModal,private router: Router,
    private Modal: NgbModal ,private config:NgbDatepickerConfig, 
    public ActiveModal: NgbActiveModal, public ModalService: NgbModal, 
    private modalService: NgbModal,public customProductService:CustomProductsService) { 
      const current = new Date();
      config.minDate = { 
                         year:current.getFullYear(),month:
                         current.getMonth()+1,day:current.getDate()
                      };
      config.outsideDays='hidden';
    }

  ngOnInit(): void {
    this.value = this.quantity
    this.materialFixedPrice1 = this.price;
    this.materialIndexPrice1 = this.indexPrice;
    this.productInfo = this.index[this.indexValue];
    // this.productInfo.pricingOptionsEnum.forEach(e => {
    //   e.qp=[];
      
    //   if(e.qpMultipleChoices){
    //     if(e.qpMultipleChoices[0].description === 'Fixed QP'){     
    //       this.displayFixedQPSection = true;
    //     }else{      
    //       this.displayFixedQPSection = false;
    //     }
    //     e.qp.push({"description": e.qpMultipleChoices[0]?.description, "uniqueRowNumber":e.qpMultipleChoices[0]?.uniqueRowNumber})
    //   }
    // });
    if(this.code.commodityType=='CN'){
      this.materialIndexPrice1= this.productInfo.displayRCPriceConfig.displayRCPrice == true ? this.indexPrice : null
    }
    this.Info = this.code;
    this.activeTab = this.tabName ? this.tabName : 'none';
    this.priceTab = this.tabName ? this.tabName : 'none';
    // if(this.Info.tenderType.code=='LUMP_FIXED_PRICE' && this.index[this.indexValue].pricingOptionsEnum.length == 2){
    //   //this condition for itb type fixedlp and check if only one pricing option is getting in response along with index price then consider other.
    //   let currTab;
    //   currTab = this.index[this.indexValue].pricingOptionsEnum.filter(x=>{
    //     return  x.pricingOptions != 'INDEX_PRICE'? x: '';           
    //   });
    //   this.priceTab = currTab[0].pricingOptions;
    // }
   
    // if(this.productInfo?.pricingOptionsEnum?.length>1){
    //   if(this.Info.tenderType.code=='LUMP_FIXED_PRICE'){
    //     this.pricingOptionsTodisplay = this.productInfo?.pricingOptionsEnum.filter(x=>{
    //       return  x.pricingOptions != 'INDEX_PRICE'? x: '';           
    //     })
    //   }else{
    //     this.pricingOptionsTodisplay = this.productInfo?.pricingOptionsEnum;
    //   }
    // }
    
    if(this.indexValue>0){
      this.InitialValue = this.indexValue;
      this.FinalValue = this.indexValue+1;
      this.FinalActive = true;
      this.InitialActive = false;

    }else{
      this.InitialValue = 1;
      this.FinalValue = 2;
      this.InitialActive = true;
      this.FinalActive = false;
    }
    this.indexPriceDisabled = this.index[this.indexValue].indexPriceDisabled?this.index[this.indexValue].indexPriceDisabled:false;
    this.fixedPriceDisabled = this.index[this.indexValue].fixedPriceDisabled?this.index[this.indexValue].fixedPriceDisabled:false;
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl(),
      finalQPFromDate: new UntypedFormControl(this.productInfo.finalQPFromDate ? this.productInfo.finalQPFromDate : null),
      finalQPToDate: new UntypedFormControl(this.productInfo.finalQPToDate ? this.productInfo.finalQPToDate : null)
    });
    this.qpStartDt=this.index[this.indexValue].finalQPFromDate? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
    this.qpEndDt=this.index[this.indexValue].finalQPToDate ?this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
    this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
    this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
    this.index[this.indexValue].childList?.forEach(child => {
      if (child.isFixedDisabled == undefined) {
        child.isFixedDisabled = false;
      }
      if(child.isIndexDisabled == undefined){
        child.isIndexDisabled = false;
      }
    });
    for(let row of this.productInfo?.pricingOptionsEnum){
      row.pricingOptions === this.priceTab? this.pricingTabFlag = true: this.pricingTabFlag= false;
    }
    setTimeout(()=>{                           
      this.checkPricingOption(this.priceTab);
  }, 200);
  for(let row of this.productInfo?.pricingOptionsEnum){
  if(this.Info.tenderType.code=='LUMP_FIXED_PRICE' && (this.productInfo.productCode== '34AU NBLL' ||this.productInfo.productCode== '34AU NBLLU')&& row.pricingOptions=='LUMP_FIXED_PRICE'){
    this.changeTab('LUMP_FIXED_PRICE');
  }
  }

  // if(this.qpStartDt && this.qpEndDt){
  //   this.qpDatesRequired = true;
  // }else{
  //   this.qpDatesRequired = false;
  // }
  if(this.index[this.indexValue].pricingOptionsEnum.length==1){
    if(this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || 
    this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE' || 
    this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM'){
      this.priceModel = this.indexPrice;
    }
    else{
      this.priceModel = this.price;
    }
  }
  
  }
  
  qpChangeAction(event:any){  

    this.displayFixedQPSection = false;
      if(event.target.value === 'Fixed QP'){     
        this.displayFixedQPSection = true;
      }else{      
        this.displayFixedQPSection = false;
      }
      this.index[this.indexValue].pricingOptionsEnum[0].qp=[]; 
      this.index[this.indexValue].pricingOptionsEnum[0].qp.push({description: event.target.value, "uniqueRowNumber":event.currentTarget.options[event.currentTarget.options.selectedIndex].id})
      this.QPValuSelectedError = false;
    
  }
  toolTipSho(){
    this.isHidde = true;
    const hover = document.getElementById('differential_value');
    if(hover) hover.style.display = 'block';
  }
  toolTipHid(){
    const hover = document.getElementById('differential_value');
    if(hover) hover.style.display = 'none';
  }
  toolTipShow(i){
    this.isHidden = true;
    const hover = document.getElementById('differential_values' + i);
    if(hover) hover.style.display = 'block';
  }
  toolTipHide(i){
    const hover = document.getElementById('differential_values' + i);
    if(hover) hover.style.display = 'none';
  }
  toolTipShow1(i){
    this.isHidden1 = true;
    const hover = document.getElementById('differential_values1' + i);
    if(hover) hover.style.display = 'block';
  }
  toolTipHide1(i){
    const hover = document.getElementById('differential_values1' + i);
    if(hover) hover.style.display = 'none';
  }
  toolTipShow2(){
    this.isHidden2 = true;
    const hover = document.getElementById('differential_values2');
    if(hover) hover.style.display = 'block';
  }
  toolTipHide2(){
    this.isHidden2 = false;
    const hover = document.getElementById('differential_values2');
    if(hover) hover.style.display = 'none';
  }
  toolTipShow3(i){
    this.isHidden3 = true;
    const hover = document.getElementById('differential_values3' + i);
    if(hover) hover.style.display = 'block';
  }
  toolTipHide3(i){
    const hover = document.getElementById('differential_values3' + i);
    if(hover) hover.style.display = 'none';
  }
  changeStartEndDate(date){
    var laycanDate = this.getDateinCorrectFormat(date);
    return laycanDate;
  }
  getDateinCorrectFormat(selectedDate){
    var formattedDate = new Date(selectedDate).getDate() + '-' + (new Date(selectedDate).getMonth()+1) + '-' + new Date(selectedDate).getFullYear();
    return formattedDate;
  }

  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}
  defaultDate(){
    let date = new Date();
    this.convertedDate = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
  }
  qpFromDateSelection(selectedDate) {
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPFromDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpSD=dateTime.format();
     this.index[this.indexValue].UnsavedQPFromValue = this.qpSD;
     this.index[this.indexValue].finalQPFromDate = this.qpSD;
     }
  }
  qpToDateSelection(selectedDate){
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPToGreater=false;
      this.isFinalQPToDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpED=dateTime.format();
     this.index[this.indexValue].UnsavedQPToValue = this.qpED;
     this.index[this.indexValue].finalQPToDate = this.qpED;
     }
  } 
  checkPriceValidation($event) {
    // tslint:disable-next-line:prefer-const
    if(this.code.commodityType=='CN' && this.productInfo.childList==undefined){
      const m = this.materialFixedPrice1.match(/\d+/g);
      this.materialFixedPrice1 = m === null ? '-' : `-${m}`;
    } 
    // let s = $event.target.value.split('.');
    // if (s.length === 1) {
    //   if (s[0].length >= 4) {
    //     $event.preventDefault();
    //   }
    // }
  }
  changeTab(data): any {
    this.activeTab = data;
    if (this.activeTab === 'FIXED_PRICE') {
      this.priceTab = 'FIXED_PRICE'
    }
    else if (this.activeTab === 'INDEX_PRICE') {
      this.priceTab = 'INDEX_PRICE'
    }   
    else if(this.activeTab ==='LUMP_FIXED_PRICE'){
      this.priceTab = 'LUMP_FIXED_PRICE'

    }
    else if (this.activeTab === 'FIXED_PREMIUM') {
      this.priceTab = 'FIXED_PREMIUM'
    }
    else if (this.activeTab === 'FLOATING_PREMIUM') {
      this.priceTab = 'FLOATING_PREMIUM'
    }
    this.selectedPricingOptions = this.index[this.indexValue].pricingOptionsEnum.filter(x=>x.pricingOptions==data);
    console.log(this.selectedPricingOptions);
    
  }
  close(): any {
    this.ActiveModal.close();
  }
  checkpriceEnteredorNot(){
    if(this.code.commodityType=='CN'){
      if(this.materialFixedPrice1==0||this.materialFixedPrice1==undefined 
        ||this.materialFixedPrice1=='' || this.materialFixedPrice1==null ){
          this.FixedPriceEmpty = true;
        }
        else{
          this.FixedPriceEmpty = false;
        }
        return this.FixedPriceEmpty;
    }
    else{
      if((this.priceTab == 'INDEX_PRICE' || this.priceTab == 'LUMP_FIXED_PRICE' || this.priceTab == 'FIXED_PREMIUM') || 
      (this.index[this.indexValue].pricingOptionsEnum.length==1 && this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' )){
        if(this.code.commodityType!='IO'){
          if(this.index[this.indexValue].childList == undefined){
            if(this.index[this.indexValue].pricingOptionsEnum.length==1){
              if(this.priceModel==0||this.priceModel==undefined||this.priceModel==''  ){
                this.IndexPriceEmpty = true;
              }
              else{
                this.IndexPriceEmpty = false;
              }
            }else{
              if(this.materialIndexPrice1==0||this.materialIndexPrice1==undefined||this.materialIndexPrice1==''  ){
                this.IndexPriceEmpty = true;
              }
              else{
                this.IndexPriceEmpty = false;
              } 
            }
            
            return this.IndexPriceEmpty
          }
          else{
            this.index[this.indexValue].childList.forEach(x => {
              if(x.IndexPrice==0 || x.IndexPrice == undefined|| x.IndexPrice ==''){
                x.IndexPriceEmpty = true;
              }
              else{
                x.IndexPriceEmpty = false;
              }
            });
            if(this.index[this.indexValue].childList.filter(x=>{return x.IndexPriceEmpty == true}).length>0){
              this.IndexPriceEmpty = true;
            }
            else{
              this.IndexPriceEmpty = false;
            }
            return this.IndexPriceEmpty;
          }
        }
        else{
          this.IndexPriceEmpty = false;
          return this.IndexPriceEmpty;
        }
       
    }
    if(this.priceTab == 'FIXED_PRICE' || (this.index[this.indexValue].pricingOptionsEnum.length==1 && this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE' )){
      if(this.index[this.indexValue].childList == undefined){
        if(this.index[this.indexValue].pricingOptionsEnum.length==1){
          if(this.priceModel==0||this.priceModel==undefined||this.priceModel==''  ){
            this.FixedPriceEmpty = true;
          }
          else{
            this.FixedPriceEmpty = false;
          }
          return this.FixedPriceEmpty
        }
        else{
          if(this.materialFixedPrice1==0||this.materialFixedPrice1==undefined||this.materialFixedPrice1==''  ){
            this.FixedPriceEmpty = true;
          }
          else{
            this.FixedPriceEmpty = false;
          }
          return this.FixedPriceEmpty
        }
      
      }
      else{
        this.index[this.indexValue].childList.forEach(x => {
          if(x.FixedPrice==0 || x.FixedPrice == undefined|| x.FixedPrice ==''){
            x.FixedPriceEmpty = true;
          }
          else{
            x.FixedPriceEmpty = false;
          }
        });
        if(this.index[this.indexValue].childList.filter(x=>{return x.FixedPriceEmpty == true}).length>0){
          this.FixedPriceEmpty = true;
        }
        else{
          this.FixedPriceEmpty = false;
        }
        return this.FixedPriceEmpty;
      }
    }
    }
    
  }

  checkQPdateValidation(){
    let flag: boolean;
       //to check to and from date required
       console.log('In Validation Check');
       
      if( this.form.value.finalQPToDate == '' || this.form.value.finalQPToDate == null){
        this.isFinalQPToDateValid = true;
        //flag = this.isFinalQPToDateValid;
      }
      if(this.form.value.finalQPFromDate == '' || this.form.value.finalQPFromDate ==null){
        this.isFinalQPFromDateValid = true;
      // flag = this.isFinalQPToDateValid;
      }
    // to check to date is grater than from date
      if(!this.isFinalQPToDateValid && !this.isFinalQPFromDateValid){
       let formattedFromDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPFromDate);
       let formattedToDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPToDate);

        if(moment(formattedToDate).isBefore(moment(formattedFromDate),'day')){
          this.isFinalQPToGreater=true;
          this.form.value.finalQPToDate = '';
        }else{
          this.isFinalQPToGreater=false;
        }
      }
      flag = this.isFinalQPToGreater || this.isFinalQPFromDateValid || this.isFinalQPToDateValid;

   
   
    return  flag;
  }
  checkifQPisselected(){
    let isOneQPSelected = false;
    if(this.priceTab != 'FIXED_PRICE'){
    if(this.productInfo.isQPMultipleChoicesSelected==true){
     if(this.productInfo.pricingOptionsEnum[0].qp){
      if(this.defaultValue=='' || this.defaultValue ==null){
        isOneQPSelected = false;
      }
      else{
        isOneQPSelected = true;
      }
     }
     else{
      isOneQPSelected = false;
     }
    }
    else{
      isOneQPSelected = true; 
    }
    return isOneQPSelected;
  }  else{
    isOneQPSelected = true
  }
  return isOneQPSelected;
  }
 
  
  Openmodal() {
    let dateValidationCheck:boolean;
    let currTab;
    // if((this.indexValue+1) < this.index.length){    
      
    //   this.index[this.indexValue+1].pricingOptionsEnum[0].qp=[];
    //   if(this.index[this.indexValue+1].qpMultipleChoices && this.index[this.indexValue+1].qpMultipleChoices.length>0){
    //     if(this.index[this.indexValue+1].qpMultipleChoices[0].description == 'Fixed QP'){     
    //       this.displayFixedQPSection = true;
    //     }else{      
    //       this.displayFixedQPSection = false;
    //     }
    //     this.index[this.indexValue+1]?.pricingOptionsEnum[0]?.qp.push({"description": this.index[this.indexValue+1].qpMultipleChoices[0]?.description, "uniqueRowNumber":this.index[this.indexValue+1].qpMultipleChoices[0]?.uniqueRowNumber})
    //   }
    // }
   
    
    if (this.indexValue === this.index.length - 1) {
      console.log('inside if');
      
      let proceedFurther:boolean = this.checkpriceEnteredorNot(); 
      let QPValuSelectedlocal = this.checkifQPisselected();
     if(this.index[this.indexValue].isQuotationPeriodUnrestricted  
        && (this.index[this.indexValue].finalQPToDate!='undefined' || this.index[this.indexValue].finalQPToDate!='' || this.index[this.indexValue].finalQPToDate!=null) && (this.index[this.indexValue].finalQPFromDate!='undefined' || this.index[this.indexValue].finalQPFromDate!='' ||this.index[this.indexValue].finalQPFromDate!=null)){
          if((this.index[this.indexValue].pricingOptionsEnum.length == 1 && (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE' || this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE'))){
            dateValidationCheck = this.checkQPdateValidation();
          }else if(this.index[this.indexValue].pricingOptionsEnum.length>1 && this.priceTab != 'FIXED_PRICE'){
            dateValidationCheck = this.checkQPdateValidation();
          }else{
            dateValidationCheck = false;
          }
      }else{
        if(this.index[this.indexValue].pricingOptionsEnum[0].qp){  
          if(this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && (this.form.value.finalQPFromDate == undefined || this.form.value.finalQPToDate == undefined)){
            this.defaultValue = this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description;
            this.isFinalQPFromDateValid = true;
            this.isFinalQPToDateValid = true;
            this.displayFixedQPSection =true;
            dateValidationCheck = true;
          } else{        
            dateValidationCheck =false;
          }
        }else{
          dateValidationCheck = false;
        } 
        }
      if(!proceedFurther&& !dateValidationCheck && QPValuSelectedlocal ==true){
        this.QPValuSelectedError = false;
        this.ActiveModal.close();
        const ModalRef = this.modalService.open(TenderSelectProductsConfirmBidComponent, { centered: true, size: 'md' });
        ModalRef.componentInstance.multipleProduct = this.Info;
        this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
        if (this.code.commodityType == 'CN') {
          this.isDisabled = false;
          this.index[this.indexValue].relativePrice = this.materialFixedPrice1;
          ModalRef.componentInstance.materialFixedPrice1 = this.index[this.indexValue].relativePrice;
          this.index[this.indexValue].premiumDiscount = this.productInfo.displayRCPriceConfig.displayRCPrice == true ? this.materialIndexPrice1 : null
          ModalRef.componentInstance.materialIndexPrice1 = this.index[this.indexValue].premiumDiscount;
        }
        ModalRef.componentInstance.parameter = this.index;
        ModalRef.componentInstance.indexValue = this.indexValue;
        ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
        ModalRef.componentInstance.tabName = this.priceTab;
        if (this.productInfo?.maximumQuantity && this.productInfo?.maximumQuantity) {
          this.index[this.indexValue].Quantity = this.value;
          ModalRef.componentInstance.quantity = this.value;
        }
        if (this.productInfo) {
        
  
          if (this.productInfo.pricingOptionsEnum.length == 1 && this.code.commodityType!='CN') {
  
              for(let data of this.index){
                this.dupData=this.index.filter((x)=>x.productCode==data.productCode && x.pricingOptionsEnum[0].pricingOptions==data.pricingOptionsEnum[0].pricingOptions)
                if(this.dupData.length>1 && this.Info.commodityType=='CC'){
                  this.isDisabled=true;
                  for(let duplicateData of this.dupData){
                    if(duplicateData.childList==undefined){
                    if(data.productCode== duplicateData.productCode && data.pricingOptionsEnum[0].pricingOptions== duplicateData.pricingOptionsEnum[0].pricingOptions ){
                      if(duplicateData.materialIndexPrice1 ||duplicateData.materialFixedPrice1){
                        this.defaultPrice=data.materialIndexPrice1?data.materialIndexPrice1:data.materialFixedPrice1?data.materialFixedPrice1:'';
                      }
                    //   if(this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE'){
                    // duplicateData.materialFixedPrice1=this.materialFixedPrice1;
                    //   }else if(this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE'){
                    //    duplicateData.materialIndexPrice1=this.materialIndexPrice1; 
                    //   }
                  }
                    }
                  }
                }
                if(data.productCode!= this.index[this.indexValue].productCode || data.pricingOptionsEnum[0].pricingOptions!= this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions && (this.Info.commodityType=='CC' || this.Info.commodityType =='CA') ){
                  this.isDisabled=false;
                  if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                    if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                      this.index[this.indexValue].Quantity = this.value;
                      ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
                    }
                    this.index[this.indexValue].materialFixedPrice1 = this.priceModel;
                    ModalRef.componentInstance.materialFixedPrice1 = this.index[this.indexValue].materialFixedPrice1;
                    this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
                    this.index[this.indexValue].childList?.forEach(element => {
                      element.priceTab = this.index[this.indexValue].priceTab;
                    });
                  }
                  this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
                  if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' 
                        || this.productInfo.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE'
                          ||this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM') {
                    this.index[this.indexValue].materialIndexPrice1 = this.priceModel;
                    ModalRef.componentInstance.materialIndexPrice1 = this.index[this.indexValue].materialIndexPrice1;
                    this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
                    this.index[this.indexValue].childList?.forEach(element => {
                      element.priceTab = this.index[this.indexValue].priceTab;
                    });
                    if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                      this.index[this.indexValue].Quantity = this.value;
                      ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
                    }
                    if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
                      this.index[this.indexValue].finalQPFromDate=this.qpSD? this.qpSD:this.index[this.indexValue]?.finalQPFromDate;
                      ModalRef.componentInstance.finalQPFromDate=this.index[this.indexValue].finalQPFromDate
                      this.index[this.indexValue].finalQPToDate=this.qpED?this.qpED:this.index[this.indexValue]?.finalQPToDate;
                      ModalRef.componentInstance.finalQPToDate=this.index[this.indexValue].finalQPToDate
                    }
                  
                    // Below for inputField-CC-index price
                    //   if(this.Info.commodityType =='CC' && this.productInfo?.maximumQuantity && this.productInfo?.maximumQuantity){ 
                    //   this.index[this.indexValue].Quantity = this.quantity;
                    //     ModalRef.componentInstance.quantity=this.index[this.indexValue].Quantity;       
                    // }
                  } 
                }
                if(this.Info.commodityType=='IO' ){
                  this.isDisabled=false;
                  if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                    if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                      this.index[this.indexValue].Quantity = this.value;
                      ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
                    }
                    this.index[this.indexValue].materialFixedPrice1 = this.priceModel;
                    ModalRef.componentInstance.materialFixedPrice1 = this.index[this.indexValue].materialFixedPrice1;
                    this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
                  }
                  if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE'
                        || this.productInfo.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE'
                          || this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM') {
                    this.index[this.indexValue].materialIndexPrice1 = this.priceModel;
                    ModalRef.componentInstance.materialIndexPrice1 = this.index[this.indexValue].materialIndexPrice1;
                    this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
                    if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                      this.index[this.indexValue].Quantity = this.value;
                      ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
                    }
                    if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
                      this.index[this.indexValue].finalQPFromDate=this.qpSD? this.qpSD:this.index[this.indexValue]?.finalQPFromDate;
                      ModalRef.componentInstance.finalQPFromDate=this.index[this.indexValue].finalQPFromDate
                      this.index[this.indexValue].finalQPToDate=this.qpED?this.qpED:this.index[this.indexValue]?.finalQPToDate;
                      ModalRef.componentInstance.finalQPToDate=this.index[this.indexValue].finalQPToDate
                    }
                  
                    // Below for inputField-CC-index price
                    //   if(this.Info.commodityType =='CC' && this.productInfo?.maximumQuantity && this.productInfo?.maximumQuantity){ 
                    //   this.index[this.indexValue].Quantity = this.quantity;
                    //     ModalRef.componentInstance.quantity=this.index[this.indexValue].Quantity;       
                    // }
                  } 
                }
            }
          
          }
          if (this.productInfo.pricingOptionsEnum.length > 1 && this.code.commodityType!='CN') {
            if (this.priceTab == 'FIXED_PRICE') {
              if(this.materialFixedPrice1){
                this.index[this.indexValue].materialFixedPrice1 = this.materialFixedPrice1;
              }
              ModalRef.componentInstance.materialFixedPrice1 = this.index[this.indexValue].materialFixedPrice1;
              this.index[this.indexValue].priceTab = this.priceTab;
              this.index[this.indexValue].childList?.forEach(element => {
                element.priceTab = this.priceTab
              });
              if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                this.index[this.indexValue].Quantity = this.value;
                ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
              }
            }
            if (this.priceTab != 'FIXED_PRICE') {
              if(this.materialIndexPrice1){
                this.index[this.indexValue].materialIndexPrice1 = this.materialIndexPrice1;
              }
              ModalRef.componentInstance.materialIndexPrice1 = this.index[this.indexValue].materialIndexPrice1;
              this.index[this.indexValue].priceTab = this.priceTab;
              this.index[this.indexValue].childList?.forEach(element => {
                element.priceTab = this.priceTab
              });
              if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
                this.index[this.indexValue].Quantity = this.value;
                ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
              }
              if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
                this.index[this.indexValue].finalQPFromDate=this.qpSD? this.qpSD:this.index[this.indexValue]?.finalQPFromDate;
                ModalRef.componentInstance.finalQPFromDate=this.index[this.indexValue].finalQPFromDate
                this.index[this.indexValue].finalQPToDate=this.qpED?this.qpED:this.index[this.indexValue]?.finalQPToDate;
                ModalRef.componentInstance.finalQPToDate=this.index[this.indexValue].finalQPToDate
              }
            }
          }
        }
        this.InitialActive = false;
        this.FinalActive = true;
        this.priceTab ='none';
        this.IndexPriceEmpty = false;
        this.FixedPriceEmpty = false;
      }
      else{
        if(QPValuSelectedlocal == false){
          this.QPValuSelectedError = true;
        }
        else{
          this.QPValuSelectedError = false;
        }
      }
     
      
    }
    if (this.indexValue !== this.index.length - 1) {  
      console.log('in second if', this.index[this.indexValue].pricingOptionsEnum.length, this.priceTab);
      
      let proceedFurther:boolean = this.checkpriceEnteredorNot();
      let QPValuSelectedlocal = this.checkifQPisselected();
      let dateValidationCheck:boolean;
      if(this.index[this.indexValue].isQuotationPeriodUnrestricted  
        && (this.index[this.indexValue].finalQPToDate!='undefined' || this.index[this.indexValue].finalQPToDate!='' || this.index[this.indexValue].finalQPToDate!=null) && (this.index[this.indexValue].finalQPFromDate!='undefined' || this.index[this.indexValue].finalQPFromDate!='' ||this.index[this.indexValue].finalQPFromDate!=null)){
         
          if((this.index[this.indexValue].pricingOptionsEnum.length == 1 && (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE' || this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE'))){
            dateValidationCheck = this.checkQPdateValidation();
          }else if(this.index[this.indexValue].pricingOptionsEnum.length>1 && this.priceTab != 'FIXED_PRICE'){
            dateValidationCheck = this.checkQPdateValidation();
          }else{           
            dateValidationCheck = false;
          }
      }else{
         //dateValidationCheck = false;
  if(this.index[this.indexValue].pricingOptionsEnum[0].qp){
    
    
    if(this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description === 'Fixed QP' && (this.index[this.indexValue].finalQPToDate === undefined || this.index[this.indexValue].finalQPFromDate === undefined)){
      
      this.defaultValue = this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description;
      this.isFinalQPFromDateValid = true;
      this.isFinalQPToDateValid = true;
      this.displayFixedQPSection =true;
      dateValidationCheck = true;
    } else{
      this.displayFixedQPSection =false;
      dateValidationCheck =false;
    }
  }else{
    dateValidationCheck = false;
  }
       
      }
      if(!proceedFurther && !dateValidationCheck && QPValuSelectedlocal==true){
        this.QPValuSelectedError = false;
        if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
          if (this.index[this.indexValue].pricingOptionsEnum.length > 1) {
            this.index[this.indexValue].Quantity = this.value;
          }
          if (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' || this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
            this.index[this.indexValue].Quantity = this.value;
          }
        }
        if (this.productInfo.pricingOptionsEnum.length == 1  && this.code.commodityType!='CN') {
          if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
            this.index[this.indexValue].materialFixedPrice1 = this.priceModel;
            this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
            this.index[this.indexValue].childList?.forEach(element => {
              element.priceTab = this.index[this.indexValue].priceTab;
            });
          }
          if (this.productInfo.pricingOptionsEnum[0].pricingOptions != 'FIXED_PRICE') {
            this.index[this.indexValue].materialIndexPrice1 = this.priceModel;
            this.index[this.indexValue].priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
            this.index[this.indexValue].childList?.forEach(element => {
              element.priceTab = this.index[this.indexValue].priceTab;
            });
            if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
              this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
              this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
              
            }
          }
        }
        if (this.productInfo.pricingOptionsEnum.length > 1  && this.code.commodityType!='CN') {
          if (this.priceTab == 'FIXED_PRICE') {
            this.index[this.indexValue].materialFixedPrice1 = this.materialFixedPrice1;
            this.index[this.indexValue].priceTab = this.priceTab;
            this.index[this.indexValue].childList?.forEach(element => {
              element.priceTab = this.priceTab
            });
          }
          if (this.priceTab != 'FIXED_PRICE') {
            this.index[this.indexValue].materialIndexPrice1 = this.materialIndexPrice1;
            this.index[this.indexValue].priceTab = this.priceTab;
            this.index[this.indexValue].childList?.forEach(element => {
              element.priceTab = this.priceTab
            });
            if(this.productInfo?.isQuotationPeriodUnrestricted==true){
              this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
              this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
            }
          }
        }
        // if (this.productInfo.pricingOptionsEnum.length > 1  && this.code.commodityType!='CN'&& this.Info.tenderType.code=='LUMP_FIXED_PRICE') {
        //   if (this.priceTab == 'FIXED_PRICE') {
        //     this.index[this.indexValue].materialFixedPrice1 = this.materialFixedPrice1;
        //     this.index[this.indexValue].priceTab = this.priceTab;
        //     this.index[this.indexValue].childList?.forEach(element => {
        //       element.priceTab = this.priceTab
        //     });
        //   }
        //   if ( this.priceTab == 'LUMP_FIXED_PRICE') {
        //     this.index[this.indexValue].materialIndexPrice1 = this.materialIndexPrice1;
        //     this.index[this.indexValue].priceTab = this.priceTab;
        //     this.index[this.indexValue].childList?.forEach(element => {
        //       element.priceTab = this.priceTab
        //     });
        //     if(this.productInfo?.isQuotationPeriodUnrestricted==true){
        //       this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
        //       this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
        //     }
        //   }
        // }

        if(this.code.commodityType=='CN'){
          this.index[this.indexValue].relativePrice = this.materialFixedPrice1;
          this.index[this.indexValue].premiumDiscount = this.productInfo.displayRCPriceConfig.displayRCPrice == true ? this.materialIndexPrice1 : null;  
        }
        //let currentHighestIndex = this.index.length -  
        let previousIndexValues = []//this.index[this.indexValue];
         for(let x=0;x<=this.indexValue;x++){
          previousIndexValues = previousIndexValues.concat(this.index[x].childList);
         }
      
       
        this.indexValue = this.indexValue + 1;
        this.defaultValue =null;
        this.displayFixedQPSection = false;
        let currentIndexValues = this.index[this.indexValue];
        this.index[this.indexValue].childList?.forEach(child => {
          if (child.isFixedDisabled == undefined) {
            child.isFixedDisabled = false;
          }
          if(child.isIndexDisabled == undefined){
            child.isIndexDisabled = false;
          }
        });
        if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
          this.qpStartDt=this.index[this.indexValue].finalQPFromDate? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
          this.qpEndDt=this.index[this.indexValue].finalQPToDate ?this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;

          this.qpSD=this.index[this.indexValue].finalQPFromDate?this.index[this.indexValue].finalQPFromDate:null;
          this.qpED=this.index[this.indexValue].finalQPToDate?this.index[this.indexValue].finalQPToDate:null;

          this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
          this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
        }
        if (this.index.length > 2 && this.indexValue!= this.index.length-1) {
          this.InitialValue = this.indexValue + 1;
          this.FinalValue = this.InitialValue + 1;
          this.InitialActive = true;
          this.FinalActive = false;
        }
        else {
          this.InitialActive = false;
          this.FinalActive = true;
        }
        
        this.productInfo = this.index[this.indexValue];
        let sameProducts = this.index.filter(x=>{return (x.productCode == this.productInfo.productCode)});
        sameProducts.forEach((element,idx) => {
          if(idx!=0){
            if(element.pricingOptionsEnum.length>1){
              if(sameProducts[0].priceTab == 'FIXED_PRICE'){
                this.materialFixedPrice1  = element.materialFixedPrice1 =  sameProducts[0].materialFixedPrice1
                element.indexPriceDisabled = false;
                element.fixedPriceDisabled = true;
              }else{
                this.materialIndexPrice1 = element.materialIndexPrice1 = sameProducts[0].materialIndexPrice1
                element.fixedPriceDisabled = false;
                element.indexPriceDisabled = true;
              }
            }
            else{
              if(element.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' 
                  && element.pricingOptionsEnum[0].pricingOptions == sameProducts[0].priceTab){
                this.materialFixedPrice1 = element.materialFixedPrice1 = sameProducts[0].materialFixedPrice1
                element.fixedPriceDisabled = true;
                element.indexPriceDisabled = false;
              }
              else if(element.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' 
              && element.pricingOptionsEnum[0].pricingOptions == sameProducts[0].priceTab){
                this.materialIndexPrice1 = element.materialIndexPrice1 = sameProducts[0].materialIndexPrice1
                element.fixedPriceDisabled = false;
                element.indexPriceDisabled = true;
              }
              else{
                element.fixedPriceDisabled = false;
                element.materialFixedPrice1 = '';
                element.materialIndexPrice1 = '';
                element.indexPriceDisabled = false;
              }
            }
          }
          else{
            element.indexPriceDisabled = false;
            element.fixedPriceDisabled = false;
          }
        });
        if(sameProducts.length == 1){
  
          this.fixedPriceDisabled = false;
          this.indexPriceDisabled = false;
          sameProducts[0].fixedPriceDisabled = false;
          sameProducts[0].indexPriceDisabled = false;
          this.materialFixedPrice1 = '';
          this.materialIndexPrice1 = '';
          this.priceModel = '';
        }else{
          let currentIndex = sameProducts.find(x=>{return x.entryNumber == this.productInfo.entryNumber});
          this.fixedPriceDisabled = currentIndex.fixedPriceDisabled;
          this.materialFixedPrice1 = currentIndex.materialFixedPrice1;
          this.materialIndexPrice1 = currentIndex.materialIndexPrice1;
          this.indexPriceDisabled = currentIndex.indexPriceDisabled;
        }
        let sameChildList = [];
        if(currentIndexValues?.childList?.length>0){
          if(previousIndexValues?.length>0){
            sameChildList = currentIndexValues.childList.filter(curr=>previousIndexValues.some(pre=>pre.productCode===curr.productCode));
            if(sameChildList.length>0){
              sameChildList.forEach(arr=>{
                previousIndexValues.forEach(element => {
                  if(arr.productCode == element.productCode){
                    arr.price = element.price;
                    if(arr.pricingOptionsEnum.length==1 && element.pricingOptionsEnum.length==1){
                     if(arr.pricingOptionsEnum[0]?.pricingOptions =='INDEX_PRICE' &&  element.pricingOptionsEnum[0]?.pricingOptions == 'INDEX_PRICE')  {
                      arr.isIndexDisabled =true;
                      arr.isFixedDisabled =false;
                      arr.IndexPrice = element.IndexPrice;
                    }
                    if(arr.pricingOptionsEnum[0]?.pricingOptions =='FIXED_PRICE' &&  element.pricingOptionsEnum[0]?.pricingOptions == 'FIXED_PRICE')  {
                      arr.isIndexDisabled =false;
                      arr.isFixedDisabled =true;
                      arr.FixedPrice = element.FixedPrice;
                    }


                    }
                     
                    if(element.priceTab=='FIXED_PRICE'){
                      arr.isFixedDisabled = true;
                      arr.isIndexDisabled = false;
                      arr.FixedPrice = element.FixedPrice;
                    }
                    if(element.priceTab == 'INDEX_PRICE'){
                      arr.isIndexDisabled = true;  
                      arr.isFixedDisabled = false;
                      arr.IndexPrice = element.IndexPrice;
                    }
                  }
                });
              })
            }
          }
        }
  
        if(this.code.commodityType=='CN'){
          this.materialFixedPrice1=this.index[this.indexValue].relativePrice?this.index[this.indexValue].relativePrice:'';
          this.materialIndexPrice1=this.index[this.indexValue].premiumDiscount?this.index[this.indexValue].premiumDiscount:'';  
        }
  
        if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
          this.quantity = this.index[this.indexValue].maximumQuantity;
          this.value = this.index[this.indexValue].maximumQuantity;
        }
        // if(this.productInfo.finalQPFromDate && this.productInfo.finalQPToDate){
        //   this.qpDatesRequired = true;
        // }else{
        //   this.qpDatesRequired = false;
        // }
          if(this.Info.tenderType.code=='LUMP_FIXED_PRICE' && (this.productInfo.productCode== '34AU NBLL' ||this.productInfo.productCode== '34AU NBLLU')){
            
            if(this.index[this.indexValue].pricingOptionsEnum.length>0){{
              currTab = this.index[this.indexValue].pricingOptionsEnum.filter(x=>{
                return  x.pricingOptions == 'LUMP_FIXED_PRICE'? x: '';          
              });  
              this.priceTab = currTab[0].pricingOptions;      
            }
            }
            else{
              this.priceTab = 'none';

            }
          }
          else{
            this.priceTab = 'none';

          }
          
        // if(this.Info.tenderType.code=='LUMP_FIXED_PRICE' && this.index[this.indexValue].pricingOptionsEnum.length == 2){
        //   //this condition for itb type fixedlp and check if only one pricing option is getting in response along with index price then consider other.
        //   currTab = this.index[this.indexValue].pricingOptionsEnum.filter(x=>{
        //     return  x.pricingOptions != 'INDEX_PRICE'? x: '';           
        //   });
        //   this.priceTab = currTab[0].pricingOptions;
        // }else{
        //   this.priceTab = 'none';
        // }

        this.IndexPriceEmpty = false;
        this.FixedPriceEmpty = false;
      
      }
      else{
        if(QPValuSelectedlocal == false){
          this.QPValuSelectedError = true;
        }
        else{
          this.QPValuSelectedError = false;
        }
      }

      
    }
    
  }
  checkPricingOption(data){
    const fixedLabel = document.getElementById('FIXED_PRICE');
    const indexLabel = document.getElementById('INDEX_PRICE');
    const lumpLabel = document.getElementById('LUMP_FIXED_PRICE');
    const fixedPremLabel = document.getElementById('FIXED_PREMIUM');
    const floatingPremLabel = document.getElementById('FLOATING_PREMIUM');

     if (data === 'FIXED_PRICE') {    
      if(fixedLabel) 
      {
        fixedLabel.classList.add('active') ;
        indexLabel.classList.remove('active') ;
        lumpLabel.classList.remove('active') ;
      }
     }
    else if (data === 'INDEX_PRICE') {     
      if(indexLabel) {
        indexLabel.classList.add('active') ;
        lumpLabel.classList.remove('active') ;
        fixedLabel.classList.remove('active') ;
        }
        }   
    else if(data ==='LUMP_FIXED_PRICE'){
      if(lumpLabel) {
        lumpLabel.classList.add('active') ;}
        floatingPremLabel.classList.remove('active') ;
        indexLabel.classList.remove('active') ;
    }
    else if(data ==='FIXED_PREMIUM'){
      if(fixedPremLabel) {
        fixedPremLabel.classList.add('active') ;}
        floatingPremLabel.classList.remove('active') ;
    }
    else if(data ==='FLOATING_PREMIUM'){
      if(floatingPremLabel) {
        floatingPremLabel.classList.add('active') ;
        fixedPremLabel.classList.remove('active') ;}
    }
  }
  backToPlacebid(): any {
    let isrequiredfalse = this.code.combinedTenders.filter(x=>x.isRequired==false)
    if (this.indexValue <= 0) {
      if(isrequiredfalse.length==0 || isrequiredfalse.length==undefined){
        this.ActiveModal.close();
        this.router.navigate(['/opentenders']);
      }
      if(isrequiredfalse.length>0){
        this.ActiveModal.close();
        const ModalRef = this.Modal.open(TenderSelectProductsComponent, { centered: true, size: 'md' });
        ModalRef.componentInstance.productsInfo = this.Info;
        ModalRef.componentInstance.quantity = this.quantity;
        this.checkbox = this.index;
        this.checkbox.map(val => {
          val.checked = true;
          ModalRef.componentInstance.parameter = this.index;
        })
      }
      this.IndexPriceEmpty = false;
      this.FixedPriceEmpty = false;
      
    } else {
      if(this.indexValue==1){
        this.FinalValue = 2;
        this.InitialValue = 1;
        this.InitialActive = true;
        this.FinalActive = false;
      }
      else{
        this.FinalValue = this.FinalValue-1;
        this.InitialValue = this.InitialValue-1;
      }
      this.isDisabled=false
      this.fixedPriceDisabled=false;
      this.indexDisabled=false
   
      this.indexValue = this.indexValue - 1;
      // if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
      //   this.index[this.indexValue].finalQPFromDate=this.qpSD? this.qpSD:this.index[this.indexValue]?.finalQPFromDate;
      //   this.index[this.indexValue].finalQPToDate=this.qpED?this.qpED:this.index[this.indexValue]?.finalQPToDate;
      // }
      
      this.productInfo = this.index[this.indexValue];
      // this.index[this.indexValue].priceTab = this.priceTab;
      this.priceTab = this.index[this.indexValue].priceTab;
      //this.changeTab(this.priceTab);          

      if(this.code.commodityType=='CN'){
        this.materialFixedPrice1= this.index[this.indexValue].relativePrice;
        this.materialIndexPrice1= this.index[this.indexValue].premiumDiscount;
      }
      if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
        this.quantity = this.index[this.indexValue].Quantity;
        this.value = this.index[this.indexValue].Quantity;
      }
      if (this.productInfo.pricingOptionsEnum.length > 1 && this.code.commodityType!='CN') {
        if (this.priceTab == 'FIXED_PRICE') {
          this.materialFixedPrice1 = this.index[this.indexValue].materialFixedPrice1;
          this.index[this.indexValue].pricingOptionsEnum.priceTab = this.priceTab;
          this.materialIndexPrice1 = 0;
        }
        if (this.priceTab != 'FIXED_PRICE') {
          this.materialFixedPrice1 = 0;
          this.materialIndexPrice1 = this.index[this.indexValue].materialIndexPrice1;
          this.index[this.indexValue].pricingOptionsEnum.priceTab = this.priceTab;
          if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
            this.qpStartDt=this.index[this.indexValue].finalQPFromDate? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
            this.qpEndDt=this.index[this.indexValue].finalQPToDate ?this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
            this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
            this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
          }
        }                        
         // this.checkPricingOption(this.priceTab);
      }
      if (this.productInfo.pricingOptionsEnum.length == 1 && this.code.commodityType!='CN') {
        if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
          this.priceModel = this.index[this.indexValue].materialFixedPrice1;
          this.materialIndexPrice1 = 0;
          this.index[this.indexValue].pricingOptionsEnum.priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;

        }
        if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
          this.materialFixedPrice1 = 0;
          this.index[this.indexValue].pricingOptionsEnum.priceTab = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
          this.priceModel = this.index[this.indexValue].materialIndexPrice1;
          if(this.index[this.indexValue]?.isQuotationPeriodUnrestricted==true){
            this.qpStartDt=this.index[this.indexValue].finalQPFromDate? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
            this.qpEndDt=this.index[this.indexValue].finalQPToDate ?this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
            this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
            this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
          }

        }

      }

      // if(this.productInfo.finalQPFromDate && this.productInfo.finalQPToDate){
      //   this.qpDatesRequired = true;
      // }else{
      //   this.qpDatesRequired = false;
      // }
      if(this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp){
        this.defaultValue = this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(this.defaultValue == 'Fixed QP'){
          this.displayFixedQPSection = true;
          this.qpStartDt=this.index[this.indexValue].finalQPFromDate? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
          this.qpEndDt=this.index[this.indexValue].finalQPToDate ?this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
          this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
          this.form.controls['finalQPToDate'].setValue(this.qpEndDt);

        }else{
          this.displayFixedQPSection =false;
        }

      }
      
      let currentBackIndex = this.index[this.indexValue];
      this.fixedPriceDisabled = currentBackIndex.fixedPriceDisabled?currentBackIndex.fixedPriceDisabled:false;
      this.indexPriceDisabled = currentBackIndex.indexPriceDisabled? currentBackIndex.indexPriceDisabled:false;
      this.IndexPriceEmpty = false;
      this.FixedPriceEmpty = false;
        setTimeout(()=>{                           
          this.checkPricingOption(this.priceTab);
      }, 200);
    }


  }
  divide(){
    if(this.code.commodityType=='CN' && this.code.childList==undefined){
      //this.materialIndexPrice1= (this.materialFixedPrice1/ 1000);
      if(!isNaN(this.materialFixedPrice1)){
        //this.materialFixedPrice1 = Math.abs(this.materialFixedPrice1)
        this.materialIndexPrice1= (this.materialFixedPrice1/ 1000);
        this.materialIndexPrice1 = Number(this.materialIndexPrice1.toFixed(5));
      }
      else{
        this.materialFixedPrice1 = null;
        this.materialIndexPrice1 = null;
      }
    }
  }
  omit_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k==46 ||(k >= 48 && k <= 57)); 
  }
  Omit_Special_Char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32|| k==45 || k==46 ||(k >= 48 && k <= 57)); 
  }
  decimalFilter(event: any) {
  const reg = /^-?\d*(\.\d{0,4})?$/;
  let input = event.target.value + String.fromCharCode(event.charCode);

  if (!reg.test(input)) {
      event.preventDefault();
  }
  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
  }
  getPremiumIndex(premiumIndex){
    return this.customProductService.getPremiumIndex(premiumIndex)
  }


  changeQuantity(action,step){
    let currentValue;
    if(action == 'decrease'){
      currentValue = this.value - 5000;
      currentValue >= this.productInfo.minimumQuantity? this.value = currentValue: this.value;
      
    }else if(action == 'increase'){
      currentValue= this.value + 5000;
      currentValue <= this.productInfo.maximumQuantity? this.value = currentValue : this.value;
    }
  }
  getPrefix(priceOptions,commodityType){
    return this.customProductService.getPrefix(priceOptions,commodityType)
  
  }
  getLabel(priceOptions,commodityType){
    return this.customProductService.getLabel(priceOptions,commodityType);
  }
  getUnit(priceOptions,commodityType){
    return this.customProductService.getUnit(priceOptions,commodityType);
  }
  getClass(count){
    return this.customProductService.getClass(count);
   }
}
